function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import { styled, expandBorderStyles } from '../styles'; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var Action = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread({}, $theme.typography.LabelMedium);
});
Action.displayName = "Action";
Action.displayName = 'Action';
export var Body = styled('div', function (_ref2) {
  var $theme = _ref2.$theme;
  return _objectSpread({
    marginBottom: $theme.sizing.scale600,
    color: $theme.colors.contentPrimary
  }, $theme.typography.ParagraphMedium);
});
Body.displayName = "Body";
Body.displayName = 'Body';
export var Contents = styled('div', function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    marginLeft: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600,
    marginBottom: $theme.sizing.scale600
  };
});
Contents.displayName = "Contents";
Contents.displayName = 'Contents';
export var HeaderImage = styled('img', function (_ref4) {
  var $theme = _ref4.$theme;
  return {
    borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
    borderTopRightRadius: $theme.borders.surfaceBorderRadius,
    objectFit: 'contain',
    maxWidth: '100%'
  };
});
HeaderImage.displayName = "HeaderImage";
HeaderImage.displayName = 'HeaderImage'; // by using the section tag, we can keep the h1 for the title
// https://html.spec.whatwg.org/multipage/sections.html#headings-and-sections

export var Root = styled('section', function (_ref5) {
  var $theme = _ref5.$theme;
  return {
    borderLeftWidth: '2px',
    borderTopWidth: '2px',
    borderRightWidth: '2px',
    borderBottomWidth: '2px',
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftColor: $theme.colors.borderOpaque,
    borderRightColor: $theme.colors.borderOpaque,
    borderTopColor: $theme.colors.borderOpaque,
    borderBottomColor: $theme.colors.borderOpaque,
    borderTopLeftRadius: $theme.borders.radius400,
    borderTopRightRadius: $theme.borders.radius400,
    borderBottomLeftRadius: $theme.borders.radius400,
    borderBottomRightRadius: $theme.borders.radius400,
    backgroundColor: $theme.colors.backgroundPrimary,
    overflow: 'hidden'
  };
});
Root.displayName = "Root";
Root.displayName = 'Root';
export var Thumbnail = styled('img', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread(_objectSpread({
    float: 'right',
    height: $theme.sizing.scale2400,
    width: $theme.sizing.scale2400,
    objectFit: 'cover',
    borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
    borderTopRightRadius: $theme.borders.surfaceBorderRadius,
    borderBottomLeftRadius: $theme.borders.surfaceBorderRadius,
    borderBottomRightRadius: $theme.borders.surfaceBorderRadius
  }, expandBorderStyles($theme.borders.border200)), {}, {
    margin: "0 0 ".concat($theme.sizing.scale500, " ").concat($theme.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
Thumbnail.displayName = 'Thumbnail';
export var Title = styled('h1', function (_ref7) {
  var $theme = _ref7.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.HeadingSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: $theme.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";
Title.displayName = 'Title';